import {
  PDULI_RECORDING_FAIL,
  PDULI_RECORDING_REQUEST,
  PDULI_RECORDING_RESET,
  PDULI_RECORDING_SUCCESS,
} from "../constants/recordingConstants";

export const pduli_recording_reducers = (state = { data: {} }, action) => {
  switch (action.type) {
    case PDULI_RECORDING_REQUEST:
      return { loading: true };
    case PDULI_RECORDING_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case PDULI_RECORDING_FAIL:
      return { loading: false, error: action.payload };
    case PDULI_RECORDING_RESET:
      return {};
    default:
      return state;
  }
};
